/** @jsx builderX.jsx */

import { builderX, Sprite, Image, Text, MovieClip, Button } from '@gongxigames/framework/core/fragments/BuilderX';
import bottomBar from './bottomBar';

export default (
    <Sprite name='buyBonus_bottomBar' reloadId='R-buyBonus_bottomBar'>
        {bottomBar.props.children}
        <Sprite name='buyButton'>
            <Button position={[0, 1400]} hitArea={{ width: 380, x: 26, y: 21, type: 'rectangle', height: 175 }} name='button'>
                <Sprite>
                    <Image src='buy_bonus_button_normal' />
                </Sprite>
                <Sprite>
                    <Image src='buy_bonus_button_focused' />
                </Sprite>
                <Sprite>
                    <Image src='buy_bonus_button_pressed' />
                </Sprite>
                <Sprite>
                    <Image src='buy_bonus_button_disabled' />
                </Sprite>
            </Button>
            <Sprite name='text'>
                <Text
                    position={[155, 1488]}
                    style={{
                        fontFamily: 'Arial',
                        fontSize: 60,
                        fontStyle: 'normal',
                        fill: '#FFFF00',
                        align: 'center',
                        fontWeight: 'normal'
                    }}
                    maxWidth={110}
                    name='playText'
                    localeTextID=''
                    text='PLAY'
                />
                <Text
                    position={[155, 1488]}
                    style={{
                        fontFamily: 'Arial',
                        fontSize: 60,
                        fontStyle: 'normal',
                        fill: '#FFFF00',
                        align: 'center',
                        fontWeight: 'normal'
                    }}
                    maxWidth={110}
                    name='buyText'
                    localeTextID=''
                    text='BUY'
                />
                <Text
                    position={[85, 1537]}
                    style={{
                        fontFamily: 'Arial',
                        fontSize: 60,
                        fontStyle: 'normal',
                        fill: '#FFFF00',
                        align: 'center',
                        fontWeight: 'normal'
                    }}
                    maxWidth={250}
                    name='bonusText'
                    localeTextID=''
                    text='BONUS'
                />
            </Sprite>
        </Sprite>
        <Sprite name='rubyBalance'>
            <Sprite position={[214, 1515]} name='animationContainer' />
            <MovieClip name='balanceBG'>
                <Sprite name='enabled'>
                    <Image position={[47, 1610]} name='balanceBG' src='red_panel' />
                    <Image position={[66, 1612]} scale={[0.4, 0.4]} src='ruby_bonus' />
                </Sprite>
                <Sprite name='disabled'>
                    <Image position={[47, 1610]} name='balanceBG' src='red_panel_disabled' />
                    <Image position={[66, 1612]} scale={[0.4, 0.4]} src='ruby_disabled_bonus' />
                </Sprite>
            </MovieClip>
            <Text
                position={[167, 1632]}
                style={{
                    fontFamily: 'PF DinDisplay Pro',
                    fontSize: 50,
                    fontStyle: 'normal',
                    fill: '#FFFFFF',
                    align: 'center',
                    fontWeight: 'bold'
                }}
                maxWidth={205}
                name='rubyBalanceText'
                localeTextID=''
                text='9999.99'
            />
        </Sprite>
    </Sprite>
);
